import * as moment from 'moment';
import { FormField } from '../forms/formField.model';

export class AppointmentCalendar {
    id: string;
    title: any;
    description: any;
    minute_interval: number;
    appointment_calendar_bookings: Array<any>; // TODO: Proper Type
    appointment_calendar_holidays: Array<any>; // TODO: Proper Type
    appointment_formfields: Array<FormField>;
    email: string;
    slot_capacity: number;
    [title: string]: any;

    constructor(options: any) {
        this.id = options.id;
        this.title = options.title;
        this.description = options.description;
        this.minute_interval = options.minute_interval;
        this.appointment_calendar_bookings = options.appointment_calendar_bookings;
        this.appointment_calendar_holidays = options.appointment_calendar_holidays;
        this.appointment_formfields = options.appointment_formfields;
        this.email = options.email;
        this.slot_capacity = options.slot_capacity;
    }
}

export class AppointmentCalendarHoliday {
    id: string;
    datetime_from: any;
    datetime_to: any;

    constructor(options: any) {
        this.id = options.id;
        this.datetime_from = options.datetime_from;
        this.datetime_to = options.datetime_to;
    }
}

export const CalendarDayFields: Map<number, string> = new Map([
    [0, 'sunday'],
    [1, 'monday'],
    [2, 'tuesday'],
    [3, 'wednesday'],
    [4, 'thursday'],
    [5, 'friday'],
    [6, 'saturday']
]);

export interface AppointmentCalendarData {
    day: moment.Moment;
    calendar: AppointmentCalendar;
}
